import { TableCell, TableRow, Typography } from "@mui/material";

import conf from "../../conf";

const EmptyTableRow = ({
  type,
  colSpan,
}: {
  type: string;
  colSpan: number;
}) => (
  <TableRow sx={conf.STYLE.LAST_CHILD_NO_BORDER}>
    <TableCell align="center" colSpan={colSpan}>
      <Typography fontSize={14}>No {type} found</Typography>
    </TableCell>
  </TableRow>
);

export default EmptyTableRow;
